export default __webpack_public_path__ + "static/media/bg-gradient-mbl.9bdf42ce.png";